import { TLink } from "../../../types";
import styles from "./breadcrumbs.module.less";
import { BreadcrumbsList } from "../breadcrumbs-list/breadcrumbs-list";

export type TBreadcrumbsProps = {
  items: Array<Partial<TLink>>;
};

export const Breadcrumbs = ({ items }: TBreadcrumbsProps) => {
  if (!items) {
    return null;
  }

  return (
    <section className={styles.wrapper}>
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        <BreadcrumbsList items={items} />
      </div>
    </section>
  );
};

export default Breadcrumbs;
